/**
 * Model representing the date interval for the current billing period.
 *
 * @property {Date} from
 * @property {Date} to
 */
export default class BillingAccountPeriod {
  /**
   * @param {Date} from
   * @param {Date} to
   */
  constructor({ from, to }) {
    this.from = from;
    this.to = to;
  }
}
